import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vex-addon-purchase-history-detail',
  templateUrl: './addon-purchase-history-detail.component.html',
  styleUrls: ['./addon-purchase-history-detail.component.scss']
})
export class AddonPurchaseHistoryDetailComponent implements OnInit {
  addons: any = [];
  currentAddonIndex: number = 0;

  constructor(private dialogRef: MatDialogRef<any>, public translate: TranslateService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.addons = data?.addons;
  }

  ngOnInit() {
    console.debug(this.addons);
    this.currentAddonIndex = 0;
  }

  closeModal() {
    this.dialogRef.close();
  }

  changeSlideAddon(way: string){
    if(way === 'prev' && this.currentAddonIndex >= 1){
      this.currentAddonIndex--;
    }else if(way === 'next' && this.currentAddonIndex < this.addons.length-1){
      this.currentAddonIndex++;
    }
  }

}
